import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesCrossedFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="m1.495.505 14.005 14-.99.995-1.147-1.147C12.237 14.87 10.54 15 8 15 1.438 15 .5 14.125.5 8c0-2.774.192-4.471 1.012-5.498L.505 1.495zM6.31 7.3l1.4 1.4H4V7.3zM4 4.99l1.044 1.043H4z"
                        fill="currentColor"
                    />
                    <path
                        d="m15.135 12.161-6.13-6.127H12v-1.4H7.605L4.182 1.211C5.174 1.05 6.425 1 8 1c6.563 0 7.5.875 7.5 7 0 1.806-.082 3.156-.365 4.161"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
CardLinesCrossedFilledSize16Glyph.displayName = 'CardLinesCrossedFilledSize16Glyph';
